import {createRequest} from "../submodules/naoo-web-components/Api/createRequest";

const getSendbirdSessionToken = () =>
    createRequest('main', 'get', '/sendbird_session_token', null)

export {getSendbirdSessionToken}